var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorGrabbing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_46650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5.82292C10.8981 5.46664 11.4237 5.25 12 5.25C12.7967 5.25 13.4967 5.66407 13.8965 6.28875C14.2225 6.1049 14.599 6 15 6C15.6684 6 16.2688 6.29149 16.6809 6.75429C18.668 6.84867 20.25 8.48958 20.25 10.5V12.2583C20.25 13.694 19.8753 15.1049 19.163 16.3514L17.799 18.7384C17.2649 19.6731 16.2708 20.25 15.1943 20.25H9.40789C8.43904 20.25 7.52982 19.7821 6.96669 18.9937L4.7279 15.8594C4.0919 14.969 3.75 13.9021 3.75 12.8079V10.5C3.75 8.64727 5.09359 7.10836 6.85956 6.80447C7.15254 5.90224 8.0001 5.25 9 5.25C9.57627 5.25 10.1019 5.46664 10.5 5.82292Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5.82292C10.8981 5.46664 11.4237 5.25 12 5.25C12.7967 5.25 13.4967 5.66407 13.8965 6.28875C14.2225 6.1049 14.599 6 15 6C15.6684 6 16.2688 6.29149 16.6809 6.75429C18.668 6.84867 20.25 8.48958 20.25 10.5V12.2583C20.25 13.694 19.8753 15.1049 19.163 16.3514L17.799 18.7384C17.2649 19.6731 16.2708 20.25 15.1943 20.25H9.40789C8.43904 20.25 7.52982 19.7821 6.96669 18.9937L4.7279 15.8594C4.0919 14.969 3.75 13.9021 3.75 12.8079V10.5C3.75 8.64727 5.09359 7.10836 6.85956 6.80447C7.15254 5.90224 8.0001 5.25 9 5.25C9.57627 5.25 10.1019 5.46664 10.5 5.82292ZM9.75 7.5V8.25C9.75 8.66421 10.0858 9 10.5 9C10.9142 9 11.25 8.66421 11.25 8.25V7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V8.25C12.75 8.66421 13.0858 9 13.5 9C13.9142 9 14.25 8.66421 14.25 8.25C14.25 7.83579 14.5858 7.5 15 7.5C15.4142 7.5 15.75 7.83579 15.75 8.25V9C15.75 9.41421 16.0858 9.75 16.5 9.75C16.9142 9.75 17.25 9.41421 17.25 9V8.37803C18.1239 8.68691 18.75 9.52034 18.75 10.5V12.2583C18.75 13.4329 18.4434 14.5873 17.8606 15.6072L16.4966 17.9942C16.2296 18.4616 15.7326 18.75 15.1943 18.75H9.40789C8.92346 18.75 8.46886 18.5161 8.18729 18.1219L5.9485 14.9876C5.49421 14.3515 5.25 13.5895 5.25 12.8079V10.5C5.25 9.52034 5.87611 8.68691 6.75 8.37803V11.25C6.75 11.6642 7.08579 12 7.5 12C7.91421 12 8.25 11.6642 8.25 11.25V7.5C8.25 7.08579 8.58579 6.75 9 6.75C9.41421 6.75 9.75 7.08579 9.75 7.5Z",
    fill: "#12131A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_46650",
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_46650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_46650",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorGrabbing);
export default __webpack_public_path__ + "static/media/cursorGrabbing.2b81e96dd8fb1eea7d139bedaf46a515.svg";
export { ForwardRef as ReactComponent };